import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { CardsActions } from '../../paymentMethods/cards/cardsActions';
import { AddressesActions } from '../addressesActions';
import { CardFormatterService } from '../../paymentMethods/cards/card/cardFormatter.service';
import JPAddressList from './JPAddressList';
import { REGION } from '../../../app/app.constants';

function mapStateToProps(state: IReduxRootState) {
    const { addressesMap, formOpen, loading, updatedSuccess } = state.addresses;
    const isJpRegion = state.app.appConfig.REGION == REGION.JP;

    const { cardsMap } = state.cards;
    const addresses = addressesMap ? Object.values(addressesMap) : [];
    const addressCards: { [key: string]: string[] } = {};
    const maxNumberOfAddress = state.app.appConfig.MAX_NUMBER_OF_ADDRESS ?? 1;

    const challengerPid = state.app.appConfig.CHALLENGER_PIDS.ADDRESS ?? '';
    const locale = state.app.locale;

    if (addresses && cardsMap) {
        Object.values(cardsMap).forEach((card) => {
            if (card.addressUuid && card.cardToken) {
                if (!addressCards[card.addressUuid]) {
                    addressCards[card.addressUuid] = [];
                }
                addressCards[card.addressUuid].push(
                    CardFormatterService.addSpaces(`************${card.numberLast}`, [4, 4, 4, 4]),
                );
            }
        });
    }

    return {
        maxNumberOfAddress,
        addressCards,
        addresses,
        formOpen,
        loading,
        challengerPid,
        locale,
        updatedSuccess,
        isJpRegion: isJpRegion,
    };
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
    return {
        getAddresses: () => {
            dispatch(AddressesActions.getAddresses());
            dispatch(CardsActions.getCards());
        },
        closeOverlay: () => {
            dispatch(AddressesActions.closeForm());
        },
        openOverlay: () => {
            dispatch(AddressesActions.openForm());
        },
    };
}

const AddressListJPContainer = connect(mapStateToProps, mapDispatchToProps)(JPAddressList);

export default AddressListJPContainer;
